import { render } from "./PatientsPage.vue?vue&type=template&id=4636499e"
import script from "./PatientsPage.vue?vue&type=script&lang=js"
export * from "./PatientsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__